// Breakpoint map mirroring the SCSS $breakpoints config (packages/tokens).
export const BREAKPOINTS = {
  default: 0,
  s: 480,
  m: 768,
  l: 1024,
  xl: 1280,
} as const;

export type Breakpoint = keyof typeof BREAKPOINTS;
